export enum REPORTS_TYPE {
  RF = "RF",
  VENDORS = "VENDORS",
  PM = "PM",
  COUNTRY = "COUNTRY",
  USER = "USER",
  PG_ENTRIES = "PG_ENTRIES",
  PG_BUDGET = "PG_BUDGET",
}
